<template>
  <v-navigation-drawer
    app
    clipped
    bottom
    :value="DRAWER_STATE"
    :mini-variant="DRAWER_STATE"
    :width="sidebarWidth"
    :permanent="$vuetify.breakpoint.mdAndUp"
    :mini-variant-width="sidebarMinWidth"
    :class="{ 'drawer-mini': DRAWER_STATE }"
  >
    <v-list>
      <template v-for="(item) in items">
        <v-list-item
          v-if=hasAccess(item.permissions)
          color="primary"
          :key="item.text"
          :href="item.href ? item.href : null"
          :to="item.link === '#' ? null : item.link"
          link
        >
          <v-list-item-action>
            <v-icon size="28" :color="item.color ? item.color : ''">
              {{ item.icon}}
            </v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title class="grey--text" link>
              {{ item.title }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </template>
    </v-list>
  </v-navigation-drawer>
</template>

<script lang="ts">
import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import { mapActions, mapState } from "vuex";
import { statsModule } from "@/store/modules/store-accessor";
import KeycloakSession from '@/helpers/keycloak-session'


@Component
export default class Sidebar extends Vue {

  get kcSession() {
    return new KeycloakSession()
  }

  @Prop()
  source: string;


  items= [
    {
      title: this.$i18n.t("dashboard"),
      icon: "mdi-home",
      link: "/dashboard",
      permissions: ["technician_company","distributor"],
    },
    {
      title: this.$i18n.t("consumption"),
      icon: "mdi-meter-electric-outline",
      link: "/consumption",
      permissions: ["technician_company","distributor"],
    },
    // {
    //   title: this.$i18n.t("savings"),
    //   icon: "mdi-leaf",
    //   link: "/savings",
    //   permissions: ["distributor"],
    // },
    {
      title: this.$i18n.t("inventory"),
      icon: "mdi-clipboard-list-outline",
      link: "/inventory",
      permissions: ["distributor"],
    },
    {
      title: this.$i18n.t("companies"),
      icon: "mdi-account-hard-hat-outline",
      link: "/companies",
      permissions: ["distributor"],
    },
    {
      title: this.$i18n.t("clients"),
      icon: "mdi-contacts-outline",
      link: "/clients",
      permissions: ["technician_company"],
    },
    {
      title: this.$i18n.t("installations"),
      icon: "mdi-home-city-outline",
      link: "/installations",
      permissions: ["technician_company"],
    },
    {
      title: this.$i18n.t("devices"),
      icon: "mdi-office-building-cog",
      link: "/devices",
      permissions: ["technician_company"],
    },
    {
      title: this.$i18n.t("map"),
      icon: "mdi-google-maps",
      link: "/map",
      permissions: ["technician_company","distributor"],
    },
    {
      title: this.$i18n.t("users"),
      icon: "mdi-account-group-outline",
      link: "/users",
      permissions: ["technician_company"],
    },
  ]

  sidebarWidth =  240
  sidebarMinWidth = 96

  hasAccess(permissions: []) {
    return permissions.some(el => this.kcSession.userHasRole(el));
  }


  get DRAWER_STATE() {
    return statsModule.drawerState;
  }
}


</script>

<style lang="scss">
@import "src/styles/variables";

.v-navigation-drawer:not(.v-navigation-drawer--is-mobile) {
  padding-top: 50px;
}

.v-navigation-drawer {

  .v-navigation-drawer__content {
    &::-webkit-scrollbar {
      width: 6px;
    }
    &::-webkit-scrollbar-track {
      background: transparent;
    }
    &::-webkit-scrollbar-thumb {
      background-color: $text-grey;
      border-radius: 36px;
      border: none;
    }
  }
  .v-list-item:not(.v-list-item--active) {
    .v-icon {
      color: $text-grey;
    }
  }

  .v-navigation-drawer .v-list a.v-list-item, .v-navigation-drawer .v-list div.v-list-item {
      padding-left: 32px;
  }

  .v-list-item--active {
    .v-list-item__content {
      .v-list-item__title {
        color: $title-grey !important;
      }
    }
  }

  &.drawer-mini {
    .v-list {
      div, a {
        &.v-list-item {
          color: $text-color;
          transition: 300ms all;
          padding-left: $drawer-items-padding / 4;
        }
      }
    }
  }
  .v-list {
    div,
    a {
      &.v-list-item {
        padding-left: $drawer-items-padding;
      }
      a.v-list-item {
        padding-left: $drawer-items-padding * 2;
      }
    }
  }

  .subheader {
    color: $text-grey;
    transition: 300ms all;
  }
  .hide {
    opacity: 0;
  }
  .show {
    opacity: 1;
  }
}

.v-navigation-drawer--temporary.v-navigation-drawer--clipped {
  z-index: 5;
}
</style>
